<template>
 <v-container fluid>
   <v-card flat>
    <v-toolbar
      color="grey darken-4"
      dark
      extended
      flat
    >
      <!--<v-app-bar-nav-icon></v-app-bar-nav-icon>-->
    </v-toolbar>

    <v-card
      class="mx-auto"
      max-width="800"
      style="margin-top: -64px;"
      :loading="loading"
    >
      <v-toolbar flat>
        <v-toolbar-title class="black--text">{{ $t('my_business') }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <!--<v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>-->
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>

        <v-list rounded v-if="companies.length > 0">
            <v-list-item-group v-model="item" color="primary">
              <v-list-item
                v-for="(store, i) in companies"
                :key="i"
                color="success"
                @click="goToMyStore(store)"
              >
                <v-list-item-avatar color="teal">
                  <v-img v-if="store.attributes.logoUrl" :src="store.attributes.logoUrl"></v-img>
                  <span v-else class="white--text">FT</span>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="store.attributes.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="store.attributes.description"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          
          <h2 v-else> {{$t('not_registered_business')}} </h2>

      </v-card-text>
    </v-card>
  </v-card>

  </v-container>
</template>

<script>
import Parse from 'parse'

export default {
    data() {
        return {
            item: '',
            store: {
              attributes: {
                name: '',
                city: '',
                phone: '',
                status: '',
                logoUrl: ''
              }
            },
            companies: [],
            loading: true
        }
    },
    computed: {
      
    },

    watch: {
     
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize(){
        try {
          let companies = await Parse.Cloud.run("getMyStoresBO");
          this.companies = companies
          //eslint-disable-next-line
          //console.log(this.companies);
          this.loading = false
          
        } catch (error) {
          this.$snotify.error(`${error}` , 'Comercios', {
            timeout: 4000,
            preventDuplicates: true
          });
        }
        
      },

      goToMyStore(store){
        this.$router.push('/tomahawk/' + store.id)
      }

    },
}
</script>